import { GridView, Menu } from '@mui/icons-material';
import { Box } from '@mui/material';

import { AnalyticsService } from '@/services';
import {
  selectIsLpsListView,
  useAppDispatch,
  useAppSelector,
  userPreferencesActions,
} from '@/store';

export const ViewToggle = () => {
  const dispatch = useAppDispatch();

  const isListView = useAppSelector(selectIsLpsListView);

  const onChange = (value: boolean) => {
    AnalyticsService.learningPathViewModeToggled({
      viewMode: value ? 'list' : 'grid',
    });
    dispatch(userPreferencesActions.setIsLpsListView(value));
  };

  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'stretch',
        border: 1,
        borderColor: '#D6D6D6',
        borderRadius: 2,
        overflow: 'hidden',
      }}>
      <Box
        role="button"
        aria-label="List view"
        aria-pressed={isListView}
        onClick={() => onChange(true)}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          px: 2,
          py: 1,
          cursor: 'pointer',
          bgcolor: isListView ? 'secondary.medium' : 'transparent',
          color: isListView ? 'secondary.main' : 'text.main',
        }}>
        <Menu fontSize="small" />
      </Box>
      <Box
        role="button"
        aria-label="Grid view"
        aria-pressed={!isListView}
        onClick={() => onChange(false)}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          px: 2,
          py: 1,
          cursor: 'pointer',
          borderLeft: 1,
          borderColor: '#D6D6D6',
          bgcolor: !isListView ? 'secondary.medium' : 'transparent',
          color: !isListView ? 'secondary.main' : 'text.main',
        }}>
        <GridView fontSize="small" />
      </Box>
    </Box>
  );
};
